<template>
   <vue-final-modal
      v-model="reference" 
      classes="modal-container"
      content-class="reference-modal-content"
      @opened="opened()"
      @click-outside="$emit('cancel')"
      >
      <button 
         id="first-aes"
         type="button"
         class="modal__close btn btn-sm" 
         :tabindex="tabIndexNumber(2)" 
         @click="$emit('cancel')"
         >
         <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-x-lg tx-cl-white" viewBox="0 0 16 16">
            <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8 2.146 2.854Z"/>
         </svg>
      </button>
      <span class="modal__title tx-cl-white">Referencias en esta Tarjeta</span>
      <div class="reference p-0 mt-1 border-top border-bottom">
         <div class="container">
            <div :tabindex="tabIndexNumber(1)" onfocus="document.getElementById('last-aes').focus()"></div>
            <div v-for="(reference, index) in references " :key="index" 
                  class="row p-0 card-reference text-nowrap"
                  @click="addSelect(index)"
                  >
               <!-- {{rectangleCard.capitals}}
            {{referenceType}}
                  @click="sendSelect(index)"
               <div class="table-responsive" :class="cellsInBox == 2 ? 'clmn-2' : 'clmn-1'">
               <font-awesome-icon v-if="reference.selected" icon="check" class=" col-1 "/>
               <CardRectangle :rectangleCard="rectangleCard" /> -->
               <div v-if="referenceType == 'MC'" class="col-2"><b>{{reference.code}}</b></div>
               <div :class="referenceType == 'MC' ? 'col-8' : 'col-10'"><b>{{reference.name}}</b></div>
               <div class="col-2 text-center">
                  <font-awesome-icon v-if="reference.selected" icon="check" />
               </div>
            </div>
         </div>
      </div>
            <div class="row p-0 justify-content-between mx-0">
               <user-circle :circleUser="myCircle" class="col-2 mt-2"/>
               <div class="d-flex justify-content-end pt-2 px-0 col-10">
                  <!--
                  <button v-show="referenceType != 'ON'"
                  -->
                  <button v-show=" !( referenceType == 'OC' || referenceType == 'ON' ) "
                        type="button" 
                        :tabindex="tabIndexNumber(3)" 
                        class="btn btn-outline-light btn-sm me-1"
                        @click="sendSelect()"
                        >
                     Aceptar
                  </button>
                  <button type="button" 
                        id="last-aes"
                        :tabindex="tabIndexNumber(4)" 
                        class="btn btn-outline-light btn-sm me-1" 
                        @click="$emit('cancel')"
                        >
                     Salir
                  </button>
                  <div :tabindex="tabIndexNumber(5)" onfocus="document.getElementById('first-aes').focus()"></div>
               </div>
            </div>
   </vue-final-modal>
</template>

<script>


import { VueFinalModal } from 'vue-final-modal'
import { ref, computed, nextTick } from 'vue';
import { useStore } from 'vuex'

import WspService from '../../workSpace.service';

import UserCircle from '../../../../components/UserCircle.vue';

export default {

   components: {
      UserCircle,
      VueFinalModal
   },

   props: {
      referenceType: String,
      references: Array
   },

   emits: [ 'cancel', 'selected', 'check' ],

   setup(props, { emit }) {

      const initialTabIndex = ref(150)
      const reference = ref(true)
      const myCircle = ref({})
      const store = useStore()

      const currentUserId = computed(() => {
         return store.state.auth.user.id;
      })

      function addSelect( index ) {
         emit( 'check', index)
         //if ( props.referenceType == 'ON' ) {
         if ( props.referenceType == 'OC' || props.referenceType == 'ON' ) {
            nextTick(() => {
               emit('selected')
            })
         }
      }

      function opened() {
         
         //if ( props.referenceType == 'ON' ) {
         if ( props.referenceType == 'OC' || props.referenceType == 'ON' ) {
            for (let reference of props.references) {
               reference.selected = false
            }
         }
         
         WspService.getMyCircle(currentUserId.value)
         .then(response => {
            myCircle.value = response.data
         })
         .catch(error => {
            console.log(error);
         })
      }

      function sendSelect() {
         emit( 'selected')
      }

      function tabIndexNumber( value ) {
         return initialTabIndex.value + value
      }

      
      return {
         addSelect,
         reference,
         myCircle,
         opened,
         sendSelect,
         tabIndexNumber,
      }
   }
}
</script>

<style scoped>
::v-deep(.modal-container) {
  display: flex;
  justify-content: center;
  align-items: flex-start;
}
::v-deep(.reference-modal-content) {
  /*
  width: 350px;
  */
  position: relative;
  display: flex;
  flex-direction: column;
  top: 5%;
  min-width: 350px;
  max-width: 750px;
  max-height: 90%;
  padding: 0.00rem 0.25rem 0.25rem 0.25rem;
  border: 1px solid #e2e8f0;
  border-radius: 0.25rem;
  background-color: #9E9E9E ;
}
.modal__title {
  margin: 0 2rem 0 0.20rem;
  font-size: 1.25rem;
  font-weight: 450;
}
.modal__close {
  position: absolute;
  top: 0.05rem;
  right: 0.10rem;
}
.reference {
   background-color: #9E9E9E ;
   max-height: calc(100vh - 28px);
   overflow-y: auto;
   color: white;
}
.tx-cl-white {
   color: white;
}
td {
   height: 1.5rem;   
}
.card-reference {
   cursor: pointer;
}
.card-reference:hover {
   background-color: darkgrey;
}
</style>
